export const Z_INDEX_TICKS = 1;
export const Z_TIMELINE_UNDERLAY_PREVIEWS = 5;
export const Z_INDEX_TRANSITION_MARKERS = 15;
export const Z_INDEX_TRANSITION_ITEM = 10;
export const Z_INDEX_SIDE_PANEL = 20;
export const Z_INDEX_PLAYHEAD = 25;
export const Z_INDEX_TIMELINE_RESIZER = 30;
export const Z_INDEX_FADE_TOOLTIP = 50;
export const Z_INDEX_VOLUME_TOOLTIP = 50;
export const Z_INDEX_FORCE_SPECIFIC_CURSOR = 100;
export const Z_INDEX_DRAG_OVERLAY = 9999;
export const Z_INDEX_TIMELINE_SNAP_INDICATOR = 10000;
/** 에디터 내 모달: 타임라인·드래그 오버레이(z≤10000)보다 위 */
export const Z_INDEX_EDITOR_DIALOG_OVERLAY = 10050;
